<template>
  <div>
    <CCard>
      <CCardHeader>
        <strong>Address List 管理</strong>
        <small class="text-muted ml-2">/ip/firewall/address-list + /ipv6/firewall/address-list（BGP output.network 通告网段来源）</small>
        <div class="float-right">
          <CButtonGroup>
            <CButton color="primary" size="sm" @click="openModal()">新增条目</CButton>
            <CButton color="secondary" size="sm" :disabled="loading" @click="loadList">刷新</CButton>
          </CButtonGroup>
        </div>
      </CCardHeader>
      <CCardBody>
        <div v-for="r in routers" :key="r.router_id" class="mb-3">
          <div class="alist-router-header">
            <strong>{{ r.router_name }}</strong>
            <small class="text-muted ml-2">{{ r.router_host }}</small>
            <CBadge color="info" class="ml-2">{{ r.list_names.length }} 个 list / {{ r.entries.length }} 条</CBadge>
            <span class="ml-auto">
              <CButton color="primary" size="sm" @click="openModal(null, r)">新增条目</CButton>
            </span>
          </div>

          <div v-for="ln in r.list_names" :key="ln" class="alist-group">
            <div class="alist-group-header">
              <strong>{{ ln }}</strong>
              <small class="text-muted ml-2">{{ entriesOf(r, ln).length }} 条网段</small>
              <CButton color="primary" size="sm" class="ml-2" @click="openModal(null, r, ln)">添加定制条目</CButton>
            </div>
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th width="80">Family</th>
                  <th>Address</th>
                  <th width="130">来源</th>
                  <th width="90">状态</th>
                  <th width="200">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="t in entriesOf(r, ln)" :key="t.id" :class="{ 'text-muted': !t.enabled }">
                  <td>
                    <CBadge :color="t.family === 'ipv6' ? 'dark' : 'light'">{{ t.family }}</CBadge>
                  </td>
                  <td><code>{{ t.address }}</code></td>
                  <td>
                    <CBadge v-if="t.source === 'group'" color="info">组 {{ t.group_name }}</CBadge>
                    <CBadge v-else color="secondary">手动</CBadge>
                  </td>
                  <td>
                    <CBadge :color="t.enabled ? 'success' : 'secondary'">{{ t.enabled ? '启用' : '禁用' }}</CBadge>
                  </td>
                  <td>
                    <CButtonGroup v-if="t.source === 'group'" size="sm">
                      <CButton color="light" size="sm" disabled>由路由组管理</CButton>
                    </CButtonGroup>
                    <CButtonGroup v-else size="sm">
                      <CButton color="info" size="sm" @click="openModal(t, r)">编辑</CButton>
                      <CButton color="warning" size="sm" @click="toggleItem(t)">{{ t.enabled ? '禁用' : '启用' }}</CButton>
                      <CButton color="danger" size="sm" @click="deleteItem(t)">删除</CButton>
                    </CButtonGroup>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </CCardBody>
    </CCard>

    <!-- 编辑 Modal -->
    <CModal :show.sync="modal.show" :title="modal.isEdit ? '编辑 Address List 条目' : '新增 Address List 条目'" color="primary">
      <CForm>
        <CSelect
          v-if="!modal.isEdit"
          label="路由器"
          v-model="modal.form.router_id"
          :options="routerOptions"
          placeholder="请选择路由器"
          @change="onRouterChange"
        />
        <CRow>
          <CCol sm="6">
            <CInput label="List 名称（可填已有或新建）" v-model="modal.form.list_name" placeholder="如 address-list-ipv4-export-to-backbone" />
            <small v-if="listNames.length" class="text-muted">已有：{{ listNames.join('、') }}</small>
          </CCol>
          <CCol sm="6">
            <CSelect label="地址族" v-model="modal.form.family" :options="[
              { value: 'ipv4', label: 'ipv4 (/ip/firewall/address-list)' },
              { value: 'ipv6', label: 'ipv6 (/ipv6/firewall/address-list)' }
            ]" />
          </CCol>
        </CRow>
        <CInput label="Address（网段或主机）" v-model="modal.form.address" placeholder="如 172.16.0.0/16 或 198.18.11.0/24" />
        <CAlert color="info" fade>
          List 名称与路由组双身份同名时，本条目为<b>定制记录</b>：仅下发到所选路由器，独立 uuid 标记，路由组同步不会修改或删除它。
        </CAlert>
      </CForm>
      <template #footer>
        <CButtonGroup>
          <CButton color="danger" @click="modal.show = false">取消</CButton>
          <CButton color="success" :disabled="modal.loading" @click="submitItem">
            {{ modal.loading ? '保存中...' : '保存' }}
          </CButton>
        </CButtonGroup>
      </template>
    </CModal>

    <!-- 通用确认 Modal -->
    <CModal :show.sync="confirmModal.show" :title="confirmModal.title" color="primary">
      <p>{{ confirmModal.message }}</p>
      <template #footer>
        <CButtonGroup>
          <CButton color="danger" @click="confirmModal.show = false">取消</CButton>
          <CButton color="success" @click="confirmModal.callback(); confirmModal.show = false">确认</CButton>
        </CButtonGroup>
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  name: 'AddressListList',
  data() {
    return {
      loading: false,
      routers: [],
      allRouters: [],
      listNames: [],
      modal: {
        show: false,
        isEdit: false,
        editId: null,
        loading: false,
        form: this.emptyForm()
      },
      confirmModal: {
        show: false, title: '确认', message: '', callback: () => {}
      }
    }
  },
  computed: {
    routerOptions() {
      return this.allRouters.map(r => ({ value: r.id, label: `${r.name} (${r.host})` }))
    }
  },
  mounted() {
    this.loadList()
    this.loadAllRouters()
  },
  methods: {
    emptyForm() {
      return { router_id: '', family: 'ipv4', list_name: '', address: '' }
    },
    entriesOf(routerRef, listName) {
      return routerRef.entries.filter(e => e.list_name === listName)
    },
    async loadAllRouters() {
      try {
        const res = await this.$axios.get('user/router')
        if (res.data.code === 200) {
          const own = res.data.userRouter || []
          const authed = (res.data.authedRouter || []).map(a => a.router).filter(Boolean)
          this.allRouters = [...own, ...authed]
        }
      } catch (e) { /* ignore */ }
    },
    async loadList() {
      this.loading = true
      try {
        const res = await this.$axios.get('user/address-list/list')
        if (res.data.code === 200) {
          this.routers = res.data.data || []
        } else {
          this.$toasted.show(res.data.msg || '加载失败', { type: 'error' })
        }
      } catch (e) {
        this.$toasted.show('网络错误: ' + e.message, { type: 'error' })
      }
      this.loading = false
    },
    async onRouterChange() {
      this.listNames = []
      if (!this.modal.form.router_id) return
      try {
        const res = await this.$axios.get('user/address-list/list', { params: { router_id: this.modal.form.router_id } })
        if (res.data.code === 200) {
          const r = (res.data.data || [])[0]
          this.listNames = r ? r.list_names : []
        }
      } catch (e) { /* ignore */ }
    },
    showConfirm(title, message, callback) {
      this.confirmModal.title = title
      this.confirmModal.message = message
      this.confirmModal.callback = callback
      this.confirmModal.show = true
    },
    openModal(entry, routerRef, presetListName) {
      if (entry) {
        this.modal.isEdit = true
        this.modal.editId = entry.id
        this.listNames = routerRef ? routerRef.list_names : []
        this.modal.form = {
          router_id: '',
          family: entry.family,
          list_name: entry.list_name,
          address: entry.address
        }
      } else {
        this.modal.isEdit = false
        this.modal.editId = null
        this.modal.form = this.emptyForm()
        this.listNames = []
        if (routerRef) {
          this.modal.form.router_id = routerRef.router_id
          this.listNames = routerRef.list_names
        }
        if (presetListName) {
          this.modal.form.list_name = presetListName
        }
      }
      this.modal.show = true
    },
    async submitItem() {
      const f = this.modal.form
      if (!this.modal.isEdit && !f.router_id) {
        this.$toasted.show('请选择路由器', { type: 'error' })
        return
      }
      if (!f.list_name) {
        this.$toasted.show('请填写 List 名称', { type: 'error' })
        return
      }
      if (!f.address) {
        this.$toasted.show('请填写 Address', { type: 'error' })
        return
      }
      this.modal.loading = true
      try {
        let res
        if (this.modal.isEdit) {
          res = await this.$axios.post(`user/address-list/${this.modal.editId}/edit`, f)
        } else {
          res = await this.$axios.post('user/address-list/add', f)
        }
        if (res.data.code === 200) {
          this.$toasted.show('已保存', { type: 'success' })
          this.modal.show = false
          this.loadList()
        } else {
          this.$toasted.show(res.data.msg || '保存失败', { type: 'error' })
        }
      } catch (e) {
        this.$toasted.show('网络错误: ' + e.message, { type: 'error' })
      }
      this.modal.loading = false
    },
    toggleItem(item) {
      this.showConfirm('确认操作', `确认${item.enabled ? '禁用' : '启用'}条目 ${item.list_name}: ${item.address}？`, async () => {
        try {
          const res = await this.$axios.post(`user/address-list/${item.id}/toggle`)
          if (res.data.code === 200) {
            this.$toasted.show('已切换', { type: 'success' })
            this.loadList()
          } else {
            this.$toasted.show(res.data.msg || '操作失败', { type: 'error' })
          }
        } catch (e) {
          this.$toasted.show('网络错误: ' + e.message, { type: 'error' })
        }
      })
    },
    deleteItem(item) {
      this.showConfirm('确认删除', `确认删除条目 ${item.list_name}: ${item.address}？`, async () => {
        try {
          const res = await this.$axios.delete(`user/address-list/${item.id}/delete`)
          if (res.data.code === 200) {
            this.$toasted.show('已删除', { type: 'success' })
            this.loadList()
          } else {
            this.$toasted.show(res.data.msg || '删除失败', { type: 'error' })
          }
        } catch (e) {
          this.$toasted.show('网络错误: ' + e.message, { type: 'error' })
        }
      })
    }
  }
}
</script>

<style scoped>
.alist-router-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #e9ecef;
  border-radius: 4px;
  margin-bottom: 8px;
}
.alist-group {
  border: 1px dashed #ced4da;
  border-radius: 4px;
  padding: 6px 8px;
  margin: 8px 0;
}
.alist-group-header {
  margin-bottom: 6px;
}
.ml-auto {
  margin-left: auto;
}
</style>
